module.exports = __webpack_public_path__ + "img/icon-whats-online.6036ad0e.svg";